const types = {
  VENDEDOR_LOGIN: "VENDEDOR_LOGIN",
  FETCHING_START: 'FETCHING_START',
  CLIENTES_FETCHING: 'CLIENTES_FETCHING',
  TICKETS_FETCHING: 'TICKETS_FETCHING',
  CLIENTE_COBRAR: 'CLIENTE_COBRAR',
  RESET_DATA: 'RESET_DATA',
  RESET_ALL_DATA: 'RESET_ALL_DATA',
  CONFIGURACION_FETCHING: 'CONFIGURACION_FETCHING',
  FETCHING_END: 'FETCHING_END',
  REGISTRO_OK: 'Se registró con éxito el cobro',
  REGISTRO_FAILD: 'No se pudo registrar el cobro',
  MAS_TOTAL: 'No puedes pagar más del importe total',
  RESTANTE_CERO: 'No puedes pagar más del restante',
  MENOS_TOTAL: 'No puedes pagar menos del importe total',
  MAS_FACTURA: 'No puedes pagar más del saldo de una factura',
  MENOS_FACTURA_ABONO: 'No puedes pagar menos del saldo a una o más facturas, para poder dar anticipo',
  IMPORTE_CERO: 'No puedes pagar 0',
  TICKETS_ADD: 'TICKETS_ADD', 
  PDF_GENERADO: 'Se generó el PDF con éxito', 
  SAP_SEND: 'Enviado en SAP',
  SAP_LOCAL: 'No se ha enviado a SAP',
  DISPOSITIVO_OK: 'Se conectó con éxito el dispositivo',
  DISPOSITIVO_FAIL: 'No se pudo conectar con el dispositivo',
  DISPOSITIVO_DISCONECT: 'Se desconectó con éxito el dispositivo',
  PRINTER_ADD: 'PRINTER_ADD',
  PRINTER_RESET: 'PRINTER_RESET',
  PRINTER_NONE: 'No está conectado a una impresora',
  TICKETS_UPDATE: 'TICKETS_UPDATE',
  TICKET_DELETE: 'Se canceló correctamente el ticket',
  TICKET_DELETE_FAIL: 'No se pudo cancelar el ticket',
  FORMA_FATURAS: 'Pago a facturas',
  FORMA_ABONO: 'Anticipo', 
  FORMA_MIXTO: 'Pago a facturas y anticipo', 
  ABONO: 1,
  ANTICIPO: 2,
  MIXTO: 3,
  PASSWORD_NEW: 'Se cambió la contraseña con éxito',
  PASSWORD_FAIL: 'No se pudo cambiar la contraseña, vuelve a iniciar sesión e intenta de nuevo',
  PASSWORD_DIF: 'No coinciden las contraseñas',
  LOGIN_FAIL: 'Usuario o contraseña incorrecta',
  FETCH_VENDEDOR_FAIL: 'No se pudo iniciar sesión, intenta más tarde',
  SIN_REFERENCIA: 'Se debe ingresar la guia CIE ó 0000 en caso de no tenerla',
  SIN_CUENTA: 'Se debe seleccionar una cuenta bancaria',
};

export default types;